import { ActionPlanFormState } from '../pages/forms/action-plan/schema';
import { ActionReportFormState } from '../pages/forms/action-report/schema';
import { MeetingMinutesFormState } from '../pages/forms/meeting-minutes/schema';

export const enum NoticeFormType {
  MeetingMinutes = 'MeetingMinutes', // Pöytäkirja
  ActionPlan = 'ActionPlan', // Toimintasuunnitelma
  ActionReport = 'ActionReport', // Toimintakertomus
}

export enum NoticeFormState {
  Draft = 'Draft',
  AwaitingApproval = 'AwaitingApproval',
  Published = 'Published',
  Archived = 'Archived',
  Rejected = 'Rejected',
}

interface BaseNoticeForm {
  id: string;
  formState: NoticeFormState;
  buildingId: string;
  publishedAt: Date;
  createdAt: Date;
  modifiedAt: Date;
}

interface ActionPlanNotice extends BaseNoticeForm {
  formType: NoticeFormType.ActionPlan;
  formData: ActionPlanFormState;
}

interface ActionReportNotice extends BaseNoticeForm {
  formType: NoticeFormType.ActionReport;
  formData: ActionReportFormState;
}

interface MeetingMinutesNotice extends BaseNoticeForm {
  formType: NoticeFormType.MeetingMinutes;
  formData: MeetingMinutesFormState;
}

export interface NoticeRequestBody {
  formData: NoticeFormData;
  formType: NoticeFormType;
}

type NoticeFormData = ActionPlanFormState | ActionReportFormState | MeetingMinutesFormState;

/**
 * Notice as it appears to the owner of the notice.
 */
export type NoticeForm = ActionPlanNotice | ActionReportNotice | MeetingMinutesNotice;

/**
 * Publicly visible notice.
 */
export type PublicNotice =
  | Omit<ActionPlanNotice, 'createdAt' | 'modifiedAt' | 'formState'>
  | Omit<ActionReportNotice, 'createdAt' | 'modifiedAt' | 'formState'>
  | Omit<MeetingMinutesNotice, 'createdAt' | 'modifiedAt' | 'formState'>;
